import { http } from "api/http";

type WhatsNewItem = {
  id: number;
  title?: string;
  description?: string;
  date?: string;
  createdAt?: string;
  updatedAt?: string;
};

type WhatsNewResponse = {
  totalCount: number;
  result: WhatsNewItem[];
};


const getWhatsNew = (params): Promise<WhatsNewResponse> =>
  http.get("/admin/whats-new", { params }).then(res => res.data);

const createWhatsNew = (data) =>
    http.post("/admin/whats-new", data);

const updateWhatsNew = ({ id, ...data }) =>
    http.put(`/admin/whats-new/${id}`, data);
const getNewWhatsNew = () => {
  return http.get("/admin/newWhatsNew");
};

const createAdminWhatsNewInProd = (data: any) => {
  return http.post("/admin/adminWhatsNewInProd", data);
};

const updateAdminWhatsNewInProd = (data: any) => {
  return http.post("/admin/updateAdminWhatsNewInProd", data);
};

export {
    getWhatsNew,
    createWhatsNew,
    updateWhatsNew,
    getNewWhatsNew,
    createAdminWhatsNewInProd,
    updateAdminWhatsNewInProd,
};
